import { Link } from 'react-router-dom';

type CardProps = {
  value: number;
  title: string;
  to: string;
};

export const Card = ({ value, title, to }: CardProps) => {
  return (
    <Link
      to={to}
      className="flex flex-col gap-1 rounded-2xl bg-white p-6 outline outline-1 outline-offset-[-1px] outline-gray-200 transition-all hover:bg-gray-100 hover:shadow-md focus:outline-2 focus:outline-offset-0 focus:outline-procuros-green-400"
    >
      <span className="text-xs text-gray-500">{title}</span>
      <span className="text-2xl font-extrabold leading-8 text-gray-900">{value}</span>
    </Link>
  );
};
